/**
 * Check whether a value is a record type (or something that looks like it). This is really helpful when writing
 * user-defined type guards for complex types.
 *
 * "Why does this function use `keyof never`?"
 * This returns a union of all possible key types and means you don't have to hardcode that list anywhere.
 *
 * @example
 * type User = {
 *     userId: number;
 * }
 * function isUser(value: unknown) {
 *     return isRecord(value) && typeof value.userId === 'number';
 * }
 * @param value - The value to check
 * @returns Whether or not the arguments looks like a record type
 * @see {@link https://github.com/microsoft/TypeScript/issues/33025#issuecomment-524053918 keyof never}
 */
export function isRecordType(value: unknown): value is Record<keyof never, unknown> {
    return typeof value === 'object' && !!value;
}
